import { Component, ViewChild, TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Propietario } from '../../../models/propietario.model';
import { MatDialog } from '@angular/material/dialog';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng9-rut';
import { FormService } from 'src/app/services/form.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';

declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-propietario",
    templateUrl: "./propietario.component.html",
    styleUrls: ["./propietario.component.css"],
    providers: [UserService, FormService]
})

export class PropietarioComponent {

    @ViewChild('openModal', { static: true }) openModal: TemplateRef<any>;
    @ViewChild('openModalVer', { static: true }) openModalVer: TemplateRef<any>;
    public rut_pro;
    public mail_pro;
    public invalidRut: Boolean;
    public propietario: Propietario;
    public rows = [];
    public actualRow;
    public matcher = new FormService();
    public filteredOptions;
    public nombreComuna = new FormControl('', [Validators.required]);
    options = []
    public selectedPro: number = null;


    constructor(private fb: FormBuilder, private _userService: UserService,
        private rutValidator: RutValidator, private dialog: MatDialog, private spinner: NgxSpinnerService) {

        this.rut_pro = this.fb.group({
            rut: ['', [Validators.required, this.rutValidator]]
        })

        this.mail_pro = this.fb.group({
            mail: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]]
        })



        if (!JSON.parse(localStorage.getItem("propietarios"))) {
            localStorage.setItem("propietarios", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("propietarios"));
        }
        this.invalidRut = true;
        this.propietario = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', nombre_completo: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
    }

    regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    ngOnInit() {
        this.getComunas()
        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(
                startWith(''),
                map(value => this._filter(value))
            );
    }

    private _filter(value: string): string[] {
        const filterValue = ('' + value).toLowerCase();
        return this.options.filter(option => ('' + option).toLowerCase().includes(filterValue));
    }

    get_propietario(rut?, soloVer?) {
        this.propietario.nombre_completo = this.propietario.nombre.toString() + " " + this.propietario.apellido_pat.toString() + " " + this.propietario.apellido_mat.toString()
        //console.log(this.propietario.nombre_completo)

        window.scroll(0, 0);
        this.spinner.show();
        this.cleanData();
        this._userService.getPropietario(rut).subscribe(

            response => {
                //console.log('get propietarios response', response)
                if (response.message) {
                    this.propietario.rut = rut ? rut : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                } else {



                    this.propietario.rut = response.rut ? response.rut : '';
                    this.propietario.nombre = response.nombre ? response.nombre : '';
                    this.propietario.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                    this.propietario.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                    this.propietario.nombre_completo = response.nombre_completo ? response.nombre_completo : '';                   
                    this.propietario.direccion = response.direccion ? response.direccion : '';
                    this.propietario.direccion_num = response.direccion_num ? response.direccion_num : '';

                    this.propietario.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                    this.propietario.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    this.propietario.comuna = response.comuna ? response.comuna : '';
                    this.propietario.fono = response.fono ? response.fono : '';
                    this.propietario.fax = response.fax ? response.fax : '';
                    this.propietario.mail = response.mail ? response.mail : '';
                    this.propietario.recordId = response.recordId ? response.recordId : '';
                    if (soloVer) {
                        this.spinner.hide();
                        this.dialog.open(this.openModalVer);
                    }
                    else {
                        this.spinner.hide();
                        this.dialog.open(this.openModal);
                    }
                }

            },
            error => {
                console.log(error)
                this.spinner.hide();
            }
        )
    }



    cleanData() {
        this.propietario = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', nombre_completo: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
        this.rut_pro.reset()
    }

    update_propietario(rut, id) {
        this.get_propietario(rut);
        this.selectedPro = id;
        //console.log('update_propietario this.selectedPro', this.selectedPro);
    }

    savePropietario() {
        this.propietario.nombre_completo = this.propietario.nombre.toString() + " " + this.propietario.apellido_pat.toString() + " " + this.propietario.apellido_mat.toString()
        //console.log(this.propietario.nombre_completo)

        window.scroll(0, 0);
        //por si escriben un rut que ya esté ingresado
        for (let x = 0; x < this.rows.length; x++) {
            if (this.propietario.rut == this.rows[x].rut) {
                this.delete_propietario(x);
                //console.log("deleting rut:" + this.propietario.rut + "index: " + x)
            }
        }

        //elimina fila cuando la editan
        /*if (this.selectedPro != null) {
            this.delete_propietario(this.selectedPro);
            console.log("deleting rut:" + this.propietario.rut + ' this.selectedPro ' + this.selectedPro)
            this.selectedPro = null;
        }*/

        //console.log('savePropietario this.propietario', this.propietario)

        this.spinner.show();
        this._userService.savePropietario(this.propietario).subscribe(
            response => {
                this.spinner.hide();
                //console.log("save propietario component ts response", response)

                if (response.update || response.save) {
                    $("#prop_modal").modal("hide");
                    this.actualRow = localStorage.getItem("propietarios");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({
                        rut: this.propietario.rut,
                        nombre: this.propietario.nombre,
                        apellido_pat: this.propietario.apellido_pat,
                        apellido_mat: this.propietario.apellido_mat,
                        nombre_completo: this.propietario.nombre_completo,

                        direccion: this.propietario.direccion,
                        direccion_num: this.propietario.direccion_num,

                        direccion_complemento: this.propietario.direccion_complemento,
                        direccion_completa: this.propietario.direccion_completa,
                        comuna: this.propietario.comuna,
                        fono: this.propietario.fono,
                        fax: this.propietario.fax,
                        mail: this.propietario.mail,
                        recordId: this.propietario.recordId
                    })
                    //console.log('this.rows', this.rows)
                    localStorage.setItem("propietarios", JSON.stringify(this.rows));
                    this.propietario = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
                    this.rut_pro.reset()
                    this.dialog.closeAll();

                }
            },
            error => {
                console.log(error)
                this.spinner.hide();

            }
        )


    }
    delete_propietario(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("propietarios", JSON.stringify(this.rows));
                //console.log('delete_propietarios1 this.rows', this.rows)
                this.rows = JSON.parse(localStorage.getItem('propietarios'));
                //console.log('delete_propietarios2 this.rows', this.rows)
            }
        }
    }

    getComunas() {

        this._userService.getComunas().subscribe(res => {
            //console.log('res', res);
            for (let i = 0; i < res.length; i++) {
                this.options.push(res[i].fieldData.COM_Nombre)
            }

            this.filteredOptions = this.nombreComuna.valueChanges
                .pipe(
                    startWith(''),
                    map(value => this._filter(value))
                );
        }, error => {
            console.log(error)
        })
    }

}